import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import PasswordField from "../components/PasswordField";
import TopNavBar from "../components/TopNavBar";
import { useAuth } from "../context/AuthContext";
import { setAccessToken } from "../api/apiClient";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4004";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { user, isAuth, setIsAuth, setUser } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    if (!email || !password) return;

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const err = await response.json();
        setError(err.error || "Login failed");
        setLoading(false);
        return;
      }

      const data = await response.json();
      console.log("Login successful");
      console.log("Server response data:", data);

      // Store access token in memory and user data in context
      setAccessToken(data.accessToken);

      const userData = {
        userId: data.userId,
        username: data.username,
        email: data.email,
        role: data.role,
        customerPkId: data.customerPkId,
        customerName: data.customerName,
        baseLocationId: data.baseLocationId,
      };
      setUser(userData);
      setIsAuth(true); // Navigation is handled by the routes/PublicRoute component
    } catch (err) {
      console.error("Login error:", err);
      setError("An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  if (isAuth === null) {
    return <CircularProgress sx={{ display: "block", margin: "100px auto" }} />;
  }

  return (
    <>
      <TopNavBar title="Robot Cleaner Dashboard" heading={"Login"} />
      <Container maxWidth="xs">
        <Box
          sx={{
            mt: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
            <PasswordField
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Sign In"}
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
}
